module.exports = __webpack_public_path__ + "static/media/git.4766bfb4.svg";